﻿const INPUT_MUST_BE_USED_PREMISE_FOR_FORM = 'data-validation-form-premise-checked';
const INPUT_REQUIRED_IF_OTHER_EMPTY = 'data-validation-other-required-id';
const INPUT_RADIO_ONE_OF_SELECTED = 'data-validation-form-premise-atleast-one-radio';

export function formsValidNoErrors(forms, allFormsMustBeUsed = false) {
    let errorForms = formsWithErrors(forms);
    return errorForms.length === 0 && (allFormsMustBeUsed ? forms.length == validFormsStepTwo(forms).length : validFormsStepOne(forms).length > 0);
}

// get validated and used forms for step 1
export function validFormsStepOne(forms) {
    let noErrorForms = formsWithNoErrors(forms);
    let finalValidForms = noErrorForms.filter(form => {
        const formIsValid = Object.keys(form.state.byId).filter(key => {
            let isValid = false; 

            if (form.state.byId[key][INPUT_MUST_BE_USED_PREMISE_FOR_FORM]) {
                isValid = form.state.byId[key].checked;
            } else if (form.state.byId[key][INPUT_RADIO_ONE_OF_SELECTED]) {
                let checkedRadios = Object.keys(form.state.byId).filter(key => form.state.byId[key][INPUT_RADIO_ONE_OF_SELECTED] && document.getElementById(form.state.byId[key].id).checked);
                isValid = checkedRadios.length > 0; 
            } else {
                isValid = true;
            }
            
            return isValid;
        }).length === Object.keys(form.state.byId).length; 

        return formIsValid; 
    });

    return finalValidForms; 
}

// get validated forms for step2
export function validFormsStepTwo(forms) {
    let noErrorForms = formsWithNoErrors(forms);

    return noErrorForms.filter(form => {
        const formIsValid = Object.keys(form.state.byId).filter(key => {
            let isValid = true;

            if (form.state.byId[key][INPUT_MUST_BE_USED_PREMISE_FOR_FORM]) {
                isValid = form.state.byId[key].checked;
            }
            
            if (form.state.byId[key].validations.length && !form.state.byId[key][INPUT_REQUIRED_IF_OTHER_EMPTY]) {
                isValid = !!(form.state.byId[key].isChanged);
            }

            if (form.state.byId[key][INPUT_RADIO_ONE_OF_SELECTED]) {
                // todo: check for matching name (otherwise this will cause a bug if several radio groups exist in the same form)
                let checkedRadios = Object.keys(form.state.byId).filter(key => form.state.byId[key][INPUT_RADIO_ONE_OF_SELECTED] && document.getElementById(form.state.byId[key].id).checked);
                isValid = checkedRadios.length > 0; 
            } 
            
            return isValid;
        }).length === Object.keys(form.state.byId).length;

        return formIsValid; 
    });    
}

export function formsWithErrors(forms) {
    return forms.filter(form => {
        return Object.keys(form.state.byId).filter(key => {
            return typeof form.state.byId[key].error !== 'undefined' && form.state.byId[key].isUsed;
        }).length; 
    });    
}

export function formsWithNoErrors(forms) {
    return forms.filter(form => {
        return !Object.keys(form.state.byId).filter(key => {
            return typeof form.state.byId[key].error !== 'undefined' && form.state.byId[key].isUsed;
        }).length; 
    });    
}

export function getFormComponentById(form, id) {
    let results = Object.keys(form.state.byId).filter(key => {
        return typeof form.state.byId[key].id == id;
    });

    return results.length ? results[0] : null; 
}

// Phone number validation helpers
export function replaceSwedishCountryCodeWithZero(value) {
    return value.replace(/^(\+|00)46/, "0");
}

export function sanitizeNumber(value) {
    return value.replace(/[\s\-]/g, '')
}

export function startsWithZero(value) {
    return value.substr(0,1) == "0";
}

export function isNumber(value) {
    return /^[0-9]+$/.test(value)
}